module.exports = __webpack_public_path__ + "static/media/apropos_img.8b16218e.png";